import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
const bonos = [{
  num: '01',
  title: '100 Mensajes para Conseguir Clientes',
  desc: 'La biblioteca completa de scripts para WhatsApp, Instagram, LinkedIn, email y grupos de Facebook. Copiá, personalizá en 60 segundos y enviá. Sin quedarte en blanco nunca más.',
  value: '$15.000'
}, {
  num: '02',
  title: '50 Prompts IA para Freelancers',
  desc: 'Los prompts exactos para usar ChatGPT o cualquier IA en propuestas, perfiles, contenido y entregables. Ahorrá horas de trabajo con el atajo correcto.',
  value: '$18.000'
}, {
  num: '03',
  title: 'Kit de Perfiles Ganadores',
  desc: 'Templates completos para Workana, Fiverr, Upwork y LinkedIn. Títulos, descripciones, cierres y frases de autoridad listas para copiar. Tu perfil publicado y optimizado en 1 hora.',
  value: '$12.000'
}, {
  num: '04',
  title: 'Calculadora Freelancer',
  desc: 'Fórmulas simples para saber exactamente cuánto cobrar, cuántos clientes necesitás y cómo llegar a tu meta mensual. Tablas de tarifas por servicio y simulaciones de USD 100 a USD 1.000.',
  value: '$12.000'
}, {
  num: '05',
  title: 'Guía para Cobrar en Dólares desde Argentina',
  desc: 'Las 6 rutas para recibir pagos en USD explicadas de forma simple. Comparativa de Payoneer, Wise, PayPal y cripto. Checklist para cobrar sin trabarte. Qué configurar hoy para estar listo mañana.',
  value: '$10.000'
}, {
  num: '06',
  title: '200 Empresas para Prospectar',
  desc: 'La lista organizada por sector con 200 tipos de empresas para contactar hoy. Sistema de priorización ABC. Canal sugerido para cada una. Sprint de prospección de 7 días con plan hora por hora.',
  value: '$10.000'
}];
export function BonosSection() {
  return <section className="py-14 relative" data-id="element-30">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold/5 blur-[120px] rounded-full pointer-events-none" data-id="element-31"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-32">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative max-w-3xl mx-auto mb-12" data-id="element-33">
          {/* Outer glow */}
          <div className="absolute -inset-1 bg-gold rounded-3xl blur-xl opacity-30" data-id="element-34"></div>

          {/* Frame */}
          <div className="relative bg-gradient-to-br from-graphite via-petroleum to-graphite border-2 border-gold rounded-3xl p-8 md:p-10 text-center overflow-hidden shadow-2xl shadow-gold/30" data-id="element-35">
            {/* Grid pattern background */}
            <div className="absolute inset-0 opacity-[0.08] pointer-events-none" style={{
            backgroundImage: 'linear-gradient(rgba(255,209,102,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(255,209,102,0.6) 1px, transparent 1px)',
            backgroundSize: '24px 24px'
          }} data-id="element-36"></div>

            {/* Corner ribbons */}
            <div className="absolute top-0 left-0 w-16 h-16 border-t-4 border-l-4 border-gold rounded-tl-3xl pointer-events-none" data-id="element-37"></div>
            <div className="absolute top-0 right-0 w-16 h-16 border-t-4 border-r-4 border-gold rounded-tr-3xl pointer-events-none" data-id="element-38"></div>
            <div className="absolute bottom-0 left-0 w-16 h-16 border-b-4 border-l-4 border-gold rounded-bl-3xl pointer-events-none" data-id="element-39"></div>
            <div className="absolute bottom-0 right-0 w-16 h-16 border-b-4 border-r-4 border-gold rounded-br-3xl pointer-events-none" data-id="element-40"></div>

            <div className="relative z-10" data-id="element-41">
              <motion.div initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} className="inline-flex items-center gap-2 bg-gold text-graphite border border-gold px-4 py-1.5 rounded-full text-xs font-extrabold uppercase tracking-wider mb-5 shadow-lg shadow-gold/40" data-id="element-42">
                <Gift className="w-3.5 h-3.5" data-id="element-43" />
                Regalo Exclusivo
              </motion.div>
              <h2 className="text-3xl md:text-5xl font-extrabold flex items-center justify-center gap-3 md:gap-4 flex-wrap" data-id="element-44">
                <Gift className="w-8 h-8 md:w-10 md:h-10 text-gold drop-shadow-[0_0_8px_rgba(255,209,102,0.6)]" data-id="element-45" />
                <span className="text-white" data-id="element-46">6 BONOS</span>
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold via-gold to-gold drop-shadow-[0_0_12px_rgba(255,209,102,0.4)]" data-id="element-47">
                  INCLUIDOS
                </span>
                <Gift className="w-8 h-8 md:w-10 md:h-10 text-gold drop-shadow-[0_0_8px_rgba(255,209,102,0.6)]" data-id="element-48" />
              </h2>
              <div className="mt-4 mx-auto h-px w-32 bg-gradient-to-r from-transparent via-gold to-transparent opacity-70" data-id="element-49"></div>
              <p className="mt-4 text-lg md:text-xl text-gold font-bold uppercase tracking-widest" data-id="element-50">
                Siempre Gratis
              </p>
            </div>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8" data-id="element-51">
          {bonos.map((bono, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-gradient-to-b from-petroleum to-graphite border-2 border-gold rounded-2xl p-6 transition-all duration-300 relative overflow-hidden shadow-[0_0_20px_rgba(255,209,102,0.4)] hover:shadow-[0_0_35px_rgba(255,209,102,0.8)] hover:-translate-y-1" data-id="element-52">
              <div className="absolute top-0 right-0 bg-gold text-graphite font-bold px-3 py-1 rounded-bl-lg text-sm" data-id="element-53">
                Bono {bono.num}
              </div>

              <h3 className="text-lg font-bold mb-3 pr-16 text-white mt-4" data-id="element-54">
                {bono.title}
              </h3>
              <p className="text-textsecondary text-sm mb-6 min-h-[60px]" data-id="element-55">
                {bono.desc}
              </p>

              <div className="flex items-center justify-between pt-4 border-t border-white/10" data-id="element-56">
                <span className="text-textsecondary line-through text-sm" data-id="element-57">
                  Valor: {bono.value}
                </span>
                <span className="text-gold font-bold" data-id="element-58">GRATIS</span>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto bg-gold/10 border border-gold/30 rounded-xl p-6 text-center" data-id="element-59">
          <p className="text-xl md:text-2xl font-bold" data-id="element-60">
            Valor total bonos:{' '}
            <span className="line-through text-textsecondary mx-2" data-id="element-61">
              $77.000
            </span>
            <span className="text-gold" data-id="element-62">→ GRATIS con tu Compra</span>
          </p>
        </motion.div>
      </div>
    </section>;
}